import * as React from "react"

const SvgHeartMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.983 14.667q-.366 0-.7-.134a2.2 2.2 0 0 1-.633-.4L5.633 13.2a35 35 0 0 1-3.191-3.167q-1.41-1.599-1.409-3.6 0-1.717 1.148-2.866t2.886-1.15q.819 0 1.56.283.74.283 1.356.883.65-.6 1.378-.883a4.2 4.2 0 0 1 1.534-.284q1.744 0 2.917 1.15 1.17 1.152 1.171 2.867 0 2.001-1.433 3.6a40 40 0 0 1-3.217 3.184l-1 .933a2 2 0 0 1-1.35.516M7.3 5.717a2.4 2.4 0 0 0-.925-.959 2.5 2.5 0 0 0-1.304-.375q-.888 0-1.48.575Q3 5.533 3 6.44q0 .81.575 1.709.575.897 1.373 1.755.8.857 1.645 1.595.847.736 1.39 1.217.55-.5 1.404-1.235a22 22 0 0 0 1.658-1.592q.806-.855 1.388-1.74.584-.882.584-1.71 0-.907-.603-1.48-.603-.576-1.506-.576-.691 0-1.316.375-.625.376-.925.958a.7.7 0 0 1-.287.317.8.8 0 0 1-.398.1.8.8 0 0 1-.398-.1.67.67 0 0 1-.284-.317" />
  </svg>
)
export default SvgHeartMini
